import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export async function setRenderQuality(args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish, options } = context;
	
	const { quality } = args;
	if (typeof quality !== 'number' || quality < 0 || quality > 10) {
		return { success: false, error: 'quality parameter must be a number between 0 and 10' };
	}

	// Update render quality in options
	if (options) {
		(options as any).renderQuality = quality;
	}

	// Apply quality changes immediately via Three.js instance
	if (threeInstance && threeInstance.setRenderQuality) {
		threeInstance.setRenderQuality(quality);
	}

	// Note: We don't trigger a full rebuild for quality changes as setRenderQuality
	// updates materials and renderer settings in real-time
	publish('render_quality', 'changed', {
		ref: 'quality',
		old: null,
		new: quality
	});

	return { success: true, data: { quality }};
}
